import styled from 'styled-components';
import { colors } from '../../../../healtheraComponents';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const StyledRow = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const StyledText = styled.span<{ isGreen?: boolean; isRed?: boolean }>`
  font-size: 18px;
  font-weight: 700;

  color: ${(props) => {
    if (props.isGreen) {
      return colors.HEALTHERA_GREEN;
    }
    if (props.isRed) {
      return colors.HEALTHERA_RED;
    }

    return colors.DARK;
  }};
`;
